import { FeatureItem } from '@/components/FeatureItem/FeatureItem';
import { useAmelioTranslations } from '@/hooks';

export const DefineAudienceHeader = () => {
    const { t } = useAmelioTranslations();

    return (
        <FeatureItem
            className={'max-w-120 px-10 py-8'}
            heading={t('cycleEvaluationDefineAudience.header.featureItem.heading')}
            description={t('cycleEvaluationDefineAudience.header.featureItem.description')}
            icon={'users-profile-tick'}
        />
    );
};
